import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StockReportLayer from "../components/StockReportLayer";
import usePermission from "../hook/usePermission";
import AccessDeniedLayer from "../components/AccessDeniedLayer";

const StockReportPage = () => {
    const hasPermission = usePermission("stockReport", "view"); 
    return (
        <>
            <MasterLayout>
                <Breadcrumb title="Stock Report" header="Stock Report" />
                {hasPermission ? <StockReportLayer /> : <AccessDeniedLayer />}
            </MasterLayout>
        </>
    );
};

export default StockReportPage;
